export const integrationsVoucherGroupIdAppGroupId = "/integrations/voucher_group/:id/:app_group_id";
